import React from "react";
import "./PartnersComp.css";
import collegePartnerImg from "../../Images/collegePartnerImg.jpg";
import collegePartnerImg1 from "../../Images/collegePartnerImg1.avif";
import collegePartnerImg2 from "../../Images/collegePartnerImg2.png";
import collegePartnerImg3 from "../../Images/collegePartnerImg3.jpg";

const CollegePartner = () => {
  return (
    <div className="collegePartner">
      <div className="partnerCompContainer">
        <div className="partnerComp">
          <img
            src={collegePartnerImg}
            alt="collegePartnerImg"
            className="partnerCompImg"
          />
          <div className="partnerCompCover">
            <h2>College Partnerships for Career-Ready Students</h2>
            <p>
              Career Restorer partners with institutions to equip students with
              real-world skills and guidance—shaping confident, career-ready
              professionals.
            </p>
            <a href="/joinPartnerForm">
              <button>Join as Partner</button>
            </a>
          </div>
        </div>
        <div className="partnerCompSection2">
          <div className="partnerCompSection2Text">
            <h3>Empowering Colleges, Enabling Careers</h3>
            <p>
              Career Restorer partners with colleges to create a future-ready
              workforce. Our collaboration goes beyond traditional training—we
              co-design programs that align with industry needs, provide career
              counseling, and offer placement support. By integrating real-world
              skills into academic environments, we help institutions elevate
              their reputation, improve student outcomes, and foster a culture
              of career excellence. Together, we empower students to transition
              confidently from campus to corporate.
            </p>
          </div>
          <img src={collegePartnerImg1} alt="serviceApplicationImg1" />
        </div>
        <div className="partnerCompSection2">
          <img src={collegePartnerImg2} alt="serviceApplicationImg1" />
          <div className="partnerCompSection2Text">
            <h3>Training That Transforms</h3>
            <p>
              Our training modules are crafted in consultation with industry
              experts and hiring managers to ensure relevance and impact.
              Whether it's Banking & Finance, Human Resources, Digital
              Marketing, or BPO services, we deliver hands-on learning
              experiences that simulate real job environments. Students gain
              practical exposure through live projects, case studies, and mock
              interviews—making them not just job-ready, but career-resilient.
              These programs are continuously updated to reflect emerging trends
              and technologies.
            </p>
          </div>
        </div>
        <div className="partnerCompIntegration">
          <div className="IntegrationText">
            <h2>
              Unlock Opportunities Across High-Demand Industries With Practical
              Training and Placement Support
            </h2>
          </div>
          <div className="IntegrationOuterBlock">
            <div className="IntegrationBlock">
              <div className="IntegrationCards">
                <h3>1</h3>
                <h4>Banking & Financet</h4>
                <p>
                  Retail banking, financial products, compliance, investment
                  basics
                </p>
              </div>
              <div className="IntegrationCards">
                <h3>3</h3>
                <h4>Accounts</h4>
                <p>
                  Tally ERP, GST, payroll, reconciliation, Practical accounting,
                  ledger management, tax basics
                </p>
              </div>
              <div className="IntegrationCards">
                <h3>5</h3>
                <h4>BPO (Voice & Non-Voice)</h4>
                <p>
                  Communication skills, CRM tools, call handling, Accent
                  training, customer service, ticketing systems
                </p>
              </div>
            </div>
            <div className="IntegrationBlock">
              <div className="IntegrationCards">
                <h3>2</h3>
                <h4>Human Resources</h4>
                <p>
                  Recruitment, onboarding, HRMS tools, labor laws, Interviewing,
                  documentation, employee engagement
                </p>
              </div>
              <div className="IntegrationCards">
                <h3>4</h3>
                <h4>Digital Marketing</h4>
                <p>
                  SEO, SEM, social media, email marketing, analytics, Campaign
                  creation, content strategy, performance tracking
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="partnerCompSection2">
          <div className="partnerCompSection2Text">
            <h3>From Campus to Career</h3>
            <p>
              We believe that placement is not just about securing a job—it's
              about launching a meaningful career. Through our vast employer
              network, we connect students with opportunities that match their
              skills and aspirations. Our placement support includes resume
              building, interview preparation, and access to exclusive job
              fairs. Colleges benefit from higher placement rates, stronger
              alumni networks, and enhanced institutional credibility. With
              Career Restorer, students don’t just graduate—they evolve into
              professionals.
            </p>
          </div>
          <img src={collegePartnerImg3} alt="serviceApplicationImg1" />
        </div>
      </div>
    </div>
  );
};

export default CollegePartner;
